import { render, staticRenderFns } from "./UnblockUserModal.vue?vue&type=template&id=d80d39b6&scoped=true&"
import script from "./UnblockUserModal.vue?vue&type=script&lang=ts&"
export * from "./UnblockUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./UnblockUserModal.vue?vue&type=style&index=0&id=d80d39b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d39b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
